import { createContext, useState } from "react";


const initalValues = true;

export const LoadingContext = createContext(initalValues);

const LoadingContextProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(initalValues);

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export default LoadingContextProvider;
